import { MOBILE_VIEW_FULL_SCREEN } from 'HOCs/withLoadEvent';
import { api } from 'api';
import { PORTAL_NAME_MODAL_DEFINE } from 'components/common/PortalModal/config';
import { getHeaderEaPlatform } from 'components/common/func';
import { HEADER_AGENT_CODE_REFERENCE, HHMT_THEME, SENDER_ID } from 'constants';
import Cookies from 'helpers/cookies';
import { checkMaintenance } from 'helpers/maintenance';
import { isArray, isEmpty, isFunction } from 'lodash';
import { useEffect, useState } from 'react';
import { domUtils } from 'utils';
import useAuth from './useAuth';
import useCommonStore from './useCommonStore';
import { useDetectDevice } from './useDetectDevice';
import useLang from './useLang';
import usePortalModal from './usePortalModal';

const fn = null;

const useEvent = ({
  event = null,
  screenId = '',
  params = [],
  modalStyles = {},
  modalOptions = {},
  isForceToCheckEventEligible = false,
  isPreventAutoShowEventModal = false,
}) => {
  const { locate } = useLang();
  const { events } = useCommonStore();
  const { token } = useAuth();
  const { showPortalModalName } = usePortalModal();
  const { isDesktop } = useDetectDevice();

  const [isShowEvent, setShowEvent] = useState(false);
  const [showEventModal, setShowEventModal] = useState(fn);

  const senderIdStorage = Cookies.get(SENDER_ID);

  const checkEventEligible = async (eventId) => {
    try {
      const onlineRefParam =
        (isArray(params) && domUtils.findParam(params, 'onlineRef')) || {};
      const senderIdParam =
        (isArray(params) && domUtils.findParam(params, 'senderId')) || {};
      if (onlineRefParam?.value) {
        const { data } = token
          ? await api.checkEventEligible(token, eventId, onlineRefParam?.value)
          : await api.checkEventEligiblePublic(
              eventId,
              onlineRefParam?.value,
              senderIdParam?.value || senderIdStorage
            );
        if (data?.eligible) {
          setShowEvent(true);
          setShowEventModal(() => showEventModalFn(params));
        }
      } else {
        setShowEvent(false);
        setShowEventModal(fn);
      }
    } catch (error) {
      checkMaintenance(error);
      console.error(error?.message);
      setShowEvent(false);
      setShowEventModal(fn);
    }
  };

  let currentEvent =
    !isEmpty(events) && !isEmpty(screenId)
      ? events?.find((e) => e?.screenId?.includes(screenId)) || null
      : !isEmpty(event)
      ? event
      : null;
  currentEvent = {
    ...(currentEvent || {}),
    mobileView: '',
  };

  const isEventExistedAndActive =
    !isEmpty(events) && !isEmpty(currentEvent) ? currentEvent?.active : false;

  useEffect(() => {
    if (!isForceToCheckEventEligible) return;
    if (isEventExistedAndActive) {
      if (modalOptions?.isCheckEventEligible) {
        checkEventEligible(currentEvent?.id);
      } else {
        setShowEvent(true);
        if (!isPreventAutoShowEventModal) {
          setShowEventModal(() => showEventModalFn(params));
        }
      }
      Cookies.remove(SENDER_ID);
    }
  }, [isEventExistedAndActive, isForceToCheckEventEligible]);

  const showEventModalFn = (params) => {
    const paramsInitialRequired = [
      {
        key: 'lang',
        value: locate,
      },
      {
        key: 'hide_nav',
        value: 'false',
      },
      {
        key: 'eventId',
        value: currentEvent?.id,
      },
      {
        key: 'xAgentCode',
        value:
          HEADER_AGENT_CODE_REFERENCE[
            process.env.REACT_APP_APP_NAME || HHMT_THEME
          ],
      },
      {
        key: 'eaPlatform',
        value: getHeaderEaPlatform(),
      },
      ...params,
    ];
    const isFullScreen =
      !isDesktop &&
      (currentEvent?.mobileView === MOBILE_VIEW_FULL_SCREEN ||
        modalOptions?.mobileViewInitial === MOBILE_VIEW_FULL_SCREEN);
    showPortalModalName({
      name: PORTAL_NAME_MODAL_DEFINE.EVENT_IFRAME_MODAL,
      modalStyles: {
        width: modalStyles?.width,
        maxHeight: modalStyles?.maxHeight,
        borderRadius: modalStyles?.borderRadius,
      },
      modalOptions: {
        iframeSrc: domUtils.getIframeSrc(
          modalOptions?.iframeSrc || currentEvent?.formUrl,
          paramsInitialRequired
        ),
        isFullScreen,
        isFullScreenWithHeader: modalOptions?.isFullScreenWithHeader,
        action1Name: modalOptions?.action1Name,
        action2Name: modalOptions?.action2Name,
      },
      action: () => {
        Cookies.remove(SENDER_ID);
      },
      actionClose: () => {
        Cookies.remove(SENDER_ID);
      },
    });
  };

  return {
    isShowEvent,
    showEventModal: isFunction(showEventModal)
      ? showEventModal
      : () => showEventModalFn(params),
  };
};

export default useEvent;
